import { render, staticRenderFns } from "./InputData.vue?vue&type=template&id=378fe960"
import script from "./InputData.vue?vue&type=script&lang=js"
export * from "./InputData.vue?vue&type=script&lang=js"
import style0 from "./InputData.vue?vue&type=style&index=0&id=378fe960&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports